// :cow: Cosmose CONFIDENTIAL :iso:
import { Action } from '@ngrx/store';

export const SET_LANGUAGE = '[Language] Set language';

export class SetLanguage implements Action {
  readonly type = SET_LANGUAGE;

  constructor(public payload: { language: string }) {
  }
}

export type All =
  | SetLanguage;
